import { ROUTER_PATHS } from "~/routes/constants"

export const tabOptions: SideNavTabOption[] = [
  { label: "Camp info", value: ROUTER_PATHS.ADMIN_SETTINGS_CAMP_INFO },
  {
    label: "Prices",

    value: ROUTER_PATHS.ADMIN_SETTINGS_PRICES,
    //subOptions: [{ label: "General pricing", value: "general" }],
  },
  { label: "Products", value: ROUTER_PATHS.ADMIN_SETTINGS_PRODUCTS },
  { label: "Invoices", value: ROUTER_PATHS.ADMIN_SETTINGS_INVOICES },
  { label: "Coupons", value: ROUTER_PATHS.ADMIN_SETTINGS_COUPONS },
  { label: "Automated Messages", value: ROUTER_PATHS.ADMIN_SETTINGS_AUTOMATED_MESSAGES },
  { label: "Rules & terms", value: ROUTER_PATHS.ADMIN_SETTINGS_RULES_TERMS },
  { label: "Users", value: ROUTER_PATHS.ADMIN_SETTINGS_USERS },
  { label: "Sites", value: ROUTER_PATHS.ADMIN_SETTINGS_SITES },
  { label: "Reservation Import", value: ROUTER_PATHS.ADMIN_SETTINGS_RESERVATION_IMPORT },
  { label: "Camper Import", value: ROUTER_PATHS.ADMIN_SETTINGS_CAMPER_IMPORT },
]
